import { fabric } from 'fabric';
import { BoardImage } from './board-image';

export class BoardImagePdf extends BoardImage {
  public shiftFromTop: number = 0;

  // Optimizing the performance because PDFs may contain 1k images,
  // and having them vertically stacked means most of the mare out of VPT and rendering them and syncing the HTML position would be unnecessary
  override createHtmlWhenInViewport = true;

  // Because they are the responsibility of the parent group
  // For now this is not necessary as we don't process the child of groups in other services
  // But it is a defensive thing if we did that in the future
  skipRemoteAddition = true;
  skipRemoteDeletion = true;
  excludeFromExport = true;

  // since it is an image by default, we set the layout to PDF now
  customLoadingLayout = true;

  // Properties that can improve performance given that the image is static
  selectable = false;
  evented = false;
  hasControls = false;
  hasBorders = false;
  hasRotatingPoint = false;
  lockScalingX = true;
  lockScalingY = true;
  lockRotation = true;
  lockUniScaling = true;
  lockSkewingX = true;
  lockSkewingY = true;
  lockScalingFlip = true;
  lockMovementX = true;
  lockMovementY = true;
  objectCaching = true;
  statefullCache = false;
  noScaleCache = false;
  filters = [];
  crossOrigin = 'anonymous';

  override onFabricAdded() {
    super.onFabricAdded();

    this.signImageUrlIfNecessary();
    this.setInteractivityBasedOnLoadingState();
  }

  override onHtmlAdded() {
    super.onHtmlAdded();

    this.subscribeToImageLoadingState();
  }

  override isInViewport(): boolean {
    let leftTopPoint = new fabric.Point(this.group?.left ?? 0, this.group?.top ?? 0);

    if (this.group?.group) {
      // PDF is multi-selected.
      const matrix = this.group.group.calcOwnMatrix();

      leftTopPoint = fabric.util.transformPoint(leftTopPoint, matrix);
    }

    // More efficient version than calculating the absolute position of the image in the group
    return this.sessionVptService.isObjectInViewport({
      tl_x: leftTopPoint.x,
      tl_y: leftTopPoint.y + this.shiftFromTop,
      br_x: leftTopPoint.x + this.configurations.width,
      br_y: leftTopPoint.y + this.configurations.height + this.shiftFromTop,
    });
  }
}
